module.exports = __webpack_public_path__ + "static/media/continue-learning.7ea4eab3.png";